export default "__VITE_ASSET__B7mm4Byf__"